import { render, staticRenderFns } from "./FormBuilderInnerTranslatable.vue?vue&type=template&id=2a797a52&"
import script from "./FormBuilderInnerTranslatable.vue?vue&type=script&lang=js&"
export * from "./FormBuilderInnerTranslatable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports